import logo from './img/logo.png';
//import './App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid, regular, brands, icon } from '@fortawesome/fontawesome-svg-core/import.macro'
import { Route, Routes } from 'react-router-dom'
import Download from './components/Download'
import About from './components/About'
import Home from './components/Home'

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Routes>
          <Route path='/' element={<Home/>} />
          <Route path='/about' element={<About/>} />
          <Route path='/download' element={<Download/>} />
        </Routes>
        
      </header>
    </div>
  );
}

export default App;
